module.exports = __webpack_public_path__ + "img/trade-service-parts-display-black.4b05daf6.png";